import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadInitialProperties } from './utils/propertyStorage';
import { initializeUsers } from './utils/userStorage'; 

// Inicijaliziraj nekretnine i korisnike prije renderiranja aplikacije
loadInitialProperties();
initializeUsers(); 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);